// extracted by mini-css-extract-plugin
export default {"cta":"lG-z","disabled":"mG-z"};